<template>
  <div class="tile tile--service">
    <p v-if="!editing" class="text__bold text__center">{{ service.name }}</p>
    <input v-else type="text" name="name" v-model="form.name" class="text__center text__bold" />
    <p class="flex__between">
      <span class="text__bold">Type:</span>
      <span v-if="!editing">{{ service.type }}</span>
      <select v-else v-model="form.type">
        <option v-for="type in types" :value="type.url" :key="type.url">{{ type.url }}</option>
      </select>
    </p>
    <p class="flex__between">
      <span class="text__bold">Status:</span>
      <span v-if="!editing">{{ service.active ? "active" : "inactive" }}</span>
      <select v-else v-model="form.active">
        <option :value="true">active</option>
        <option :value="false">inactive</option>
      </select>
    </p>
    <p v-if="!editing" class="flex__between">
      <button class="btn btn__small btn__red" @click="toggleDelete">Delete</button>
      <button v-if="!editing" class="btn btn__small btn__green" @click="toggleEditing">Edit</button>
    </p>
    <p v-else class="flex__between">
      <button class="btn btn__small btn__red" @click="toggleEditing">Cancel</button>
      <button class="btn btn__small btn__green" @click="updateService">Done</button>
    </p>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["service", "types"],
  data() {
    return {
      editing: false,
      form: {
        _id: this.service._id,
        active: this.service.active,
        name: this.service.name,
        type: this.service.type
      },
      reset: {
        _id: this.service._id,
        active: this.service.active,
        name: this.service.name,
        type: this.service.type
      }
    };
  },
  methods: {
    ...mapActions(["startUpdateService"]),
    toggleDelete() {
      this.$emit("toggleDelete", this.service);
    },
    toggleEditing() {
      return (this.editing = !this.editing);
    },
    async updateService() {
      if (this.form.name.trim() === "") {
        return this.flash("Update error: Name cannot be blank", "error");
      }
      try {
        await this.startUpdateService(this.form);
        this.toggleEditing();
      } catch (err) {
        this.form = this.reset;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tile--service {
  margin: 15px 0;
  @include grid($rows: 50px 45px 45px 50px, $row-gap: 5px);
  input {
    width: 100%;
  }
  select {
    text-align-last: right;
    max-width: 120px;
  }
}
</style>